var map = {
	"./PizzaPals.jpg": 2708,
	"./appetizers.jpeg": 90888,
	"./bakery.jpg": 71874,
	"./beverages.jpeg": 79595,
	"./calzato.jpg": 44072,
	"./desserts.jpeg": 15472,
	"./extras.jpeg": 31912,
	"./lunch.png": 83560,
	"./party.jpeg": 5329,
	"./pizzas.jpeg": 80272,
	"./salads.jpeg": 35597,
	"./subs.jpeg": 51672,
	"./wings.jpeg": 98329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25920;